import { CheckGroupButton as Button } from './Button';
import { CheckGroupCheckbox as Checkbox } from './Checkbox';
import { CheckGroupFreeCheckbox as FreeCheckbox } from './FreeCheckBox';
import { CheckGroupFreeButton as FreeButton } from './FreeButton';
import { CheckGroup as CheckGroupComponent } from './Group';
import { CheckGroupTag as Tag } from './Tag';
import { CheckGroupFilled as Filled } from './Filled';
import { CheckGroupFreeFilled as FreeFilled } from './FreeFilled';
export var CheckGroup = Object.assign(CheckGroupComponent, {
  Button: Button,
  Checkbox: Checkbox,
  FreeButton: FreeButton,
  Tag: Tag,
  Filled: Filled,
  FreeFilled: FreeFilled,
  FreeCheckbox: FreeCheckbox
});